/**
 * Bottom navigation (NEW): For You / Favorites, plus a Chats entry on the left
 * that appears once the user has at least one author chat. Live count badges.
 */
export function TabBar({ active, favoritesCount, chatsCount = 0, chatsUnread = 0, onChange }) {
  return (
    <nav class="tabbar">
      {chatsCount > 0 && (
        <button
          type="button"
          class={`tabbar__tab ${active === 'chats' ? 'tabbar__tab--active' : ''}`}
          onClick={() => onChange('chats')}
        >
          <span class="tabbar__icon" aria-hidden="true">
            💬
            {chatsUnread > 0 && <span class="tabbar__badge">{chatsUnread}</span>}
          </span>
          <span class="tabbar__label">Chats</span>
        </button>
      )}
      <button
        type="button"
        class={`tabbar__tab ${active === 'foryou' ? 'tabbar__tab--active' : ''}`}
        onClick={() => onChange('foryou')}
      >
        <span class="tabbar__icon" aria-hidden="true" style="
  transform: scale(1.4) translate(0, -3px);">
          ⌂
        </span>
        <span class="tabbar__label">For You</span>
      </button>
      <button
        type="button"
        class={`tabbar__tab ${active === 'favorites' ? 'tabbar__tab--active' : ''}`}
        onClick={() => onChange('favorites')}
      >
        <span class="tabbar__icon" aria-hidden="true">
          ★
          {favoritesCount > 0 && <span class="tabbar__badge">{favoritesCount}</span>}
        </span>
        <span class="tabbar__label">Favorites</span>
      </button>
    </nav>
  );
}
